<template>
  <div class="container">
    <!-- Header -->
    <Header></Header>
    <div class="head-img">
      <div class="img-item" v-for="(item,index) in headImg" :key="index">
        <img :src="item.img" :class="{'is-show':item.id == indexId}">
      </div>
    </div>
    <!-- 主内容 -->
    <div class="container_s">
      <!-- 二级导航-->
      <div class="second-banner">
        <div v-for="(item,index) in secbanner" :key="index">
          {{item}}
        </div>
      </div>
      <!-- 行业概述-->
      <div class="demand">
        <h2>行业概述</h2>
        <div class="common-border"></div>
        <div class="demand-container">
          <div class="demand-item">
            <div class="demand-img">
              <img :src="demandimg">
            </div>
            <div class="demand-text"><span>{{demandtext}}</span></div>
          </div>
        </div>
      </div>
    <!--方案简介 -->
      <div class="solution">
        <h2>方案简介</h2>
        <div class="common-border"></div>
        <div class="solution-container">
          <div class="solution1">
            <div class="inner-item">
              <div class="solution-title">大数据安全咨询服务</div>
              <span class="solution-border"></span>
              <span>{{soultionInfo.serviceSolution}}</span>
            </div>
          </div>
          <div class="solution2">
            <div class="inner-item">
              <div class="solution-title">大数据安全运营服务</div>
              <span class="solution-border"></span>
              <span>{{soultionInfo.operateSolution}}</span>
            </div>
          </div>
          <div class="solution3">
            <div class="inner-item">
              <div class="solution-title">大数据安全技术支撑服务</div>
              <span class="solution-border"></span>
              <span>{{soultionInfo.holdSolution}}</span>
            </div>
          </div>
          <div class="solution4">
            <div class="inner-item">
              <div class="solution-title">大数据安全监审服务</div>
              <span class="solution-border"></span>
              <span>{{soultionInfo.supervisionSolution}}</span>
            </div>
          </div>
          <div class="solution5">
            <div class="inner-item">
              <div class="solution-title">数据安全协同运营平台</div>
              <span class="solution-border"></span>
              <span>{{soultionInfo.coordinationSolution}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 我们能做什么-->
    <div class="value">
      <h2>我们能做什么</h2>
      <div class="common-border"></div>
      <div class="value-container">
        <div class="value-item">
          <div class="value-img">
            <img :src="doImg" >
          </div>
          <div class="value-text"><span v-html="soultionInfo.firSolution"></span></div>
        </div>
        <div class="value-item">
          <div class="value-img">
            <img :src="doImg">
          </div>
          <div class="value-text"><span v-html="soultionInfo.secSolution"></span></div>
        </div>
        <div class="value-item">
          <div class="value-img">
            <img :src="doImg">
          </div>
          <div class="value-text"><span v-html="soultionInfo.tirSolution"></span></div>
        </div>
      </div>
    </div>
    <!--客户案例 -->
    <div class="case">
      <h2>客户案例</h2>
      <div class="common-border"></div>
      <div class="case-container">
        <swiper class="caseswiper" :options="swipercaseOption" ref="mycaseswiper">
          <swiper-slide class="case-slide" v-for="(item,index) in caseInfo" :key="index">
            <div class="inner-case" :data-id="index" @click="slideto($event)">
              <img :src="item.img">
              <span class="name">{{item.name}}</span>
            </div>
          </swiper-slide>
          <a class="arrow-left" @click="prevsuccess"><img :src="prev"></a>
          <a class="arrow-right" @click="nextsuccess"><img :src="next"></a>
        </swiper>
      </div>
    </div>
    <!-- Footer -->
    <Footer></Footer>
  </div>
</template>

<script>
import axios from 'axios'
import {Swiper, SwiperSlide} from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
var CONFIG = require('../../common/config.js')
var base_url = CONFIG.API_URL.BASE_URL
var img_url = CONFIG.API_URL.IMG_URL

export default {
  components: {
    Swiper,
    SwiperSlide
  },
  data () {
    return {
      base_url: base_url,
      list: [],
      indexId: this.$route.query.id,
      headImg: [
        {
          id: 26,
          img: '../../static/images/zhengWu.png'
        },
        {
          id: 27,
          img: '../../static/images/jinRong.png'
        },
        {
          id: 28,
          img: '../../static/images/yiWei.png'
        },
        {
          id: 29,
          img: '../../static/images/gaoXiao.png'
        },
        {
          id: 30,
          img: '../../static/images/tongXin.png'
        }
      ],
      cate_id: 0,
      cate_name: '',
      prev: '../../static/images/Image 39.png',
      next: '../../static/images/Image 40.png',
      secbanner: [
        '行业概述',
        '方案简介',
        '我们能做什么',
        '客户案例',
        '联系我们'
      ],
      doImg: '../../static/images/Image 48.png',
      demandimg: '',
      demandtext: '',
      soultionInfo: '',
      caseInfo: [],
      swipercaseOption: {
        slidesPerView: 6,
        slideToClickedSlide: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  created: function (options) {
    var that = this

    // 获取方案
    that.getSolutionInfo()
  },
  watch: {
    $route: function () {
      var that = this
      // 获取方案
      that.getSolutionInfo()
      this.indexId = this.$route.query.id
    }
  },
  methods: {
    // 获取案例
    getSolutionInfo: function () {
      var that = this
      // 页面携带参数
      var cate_id = this.$route.query.id
      var cate_name = this.$route.query.name
      that.cate_id = cate_id
      that.cate_name = cate_name
      axios.post(base_url + 'front/getSolutionInfo', {'cate': cate_id}).then(function (res) {
        var data = res.data
        if (data.code == 0) {
          var data = data.result
          that.demandtext = data[0]['summaryContext']
          that.demandimg = img_url + data[0]['summaryImg']
          that.soultionInfo = data[0]
          let caseArr = []
          let arr = []
          caseArr['img'] = img_url + data[0]['caseImg']
          caseArr['name'] = data[0]['caseName']
          arr.push(caseArr)
          that.caseInfo = arr
        }
      })
    },
    prevsuccess () {
      this.$refs.mycaseswiper.$swiper.slidePrev()
      // this.$refs.mycaseswiper.$swiper.setTranslate(800)
    },
    nextsuccess () {
      this.$refs.mycaseswiper.$swiper.slideNext()
      // this.$refs.mycaseswiper.$swiper.setTranslate(-800)
    },
    /**
       * 解决方案详情
       */
    solutionDetail: function (e) {
      var that = this
      var id = e.currentTarget.dataset.id
      that.$router.push({ path: '/solutionDetail?id=' + id })
    }

  }
}
</script>

<style scoped>
  @import url("./solution.css");
</style>



// WEBPACK FOOTER //
// src/views/solution/solution.vue